import _find from 'lodash/find';
import _remove from 'lodash/remove';
import _findIndex from 'lodash/findIndex';
import template from './groups.html';

class GroupsComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    GroupService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.GroupService = GroupService;
    this.columnKeys = ['name'];
  }

  $onInit() {
    if (this.me.roleName === 'MANAGER') {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }
  }

  addGroup(ev) {
    const confirm = this.$mdDialog.prompt()
      .title('Dodaj nową grupę')
      .textContent('Wpisz nazwę nowej grupy.')
      .placeholder('Wpisz nazwę')
      .ariaLabel('Wpisz nazwę')
      .targetEvent(ev)
      .multiple(true)
      .ok('Zapisz')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(result => {
      const group = {name: result};
      this.GroupService.addGroup(group)
        .then(() => {
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Dodano grupę')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  editGroup(groupId, ev) {
    const groupToEdit = {...this.groups.filter(item => item.id === groupId)[0]};
    const confirm = this.$mdDialog.prompt()
      .title('Edytuj grupę')
      .textContent('Zmień nazwę grupy.')
      .placeholder('Wpisz nową nazwę')
      .ariaLabel('Wpisz nową nazwę')
      .initialValue(groupToEdit.name)
      .targetEvent(ev)
      .multiple(true)
      .ok('Zapisz')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(result => {
      groupToEdit.name = result;
      this.GroupService.editGroup(groupToEdit).then(() => {
        const index = _findIndex(this.groups, ['id', groupToEdit.id]);
        this.groups.splice(index, 1, groupToEdit);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie zmieniono nazwę grupy')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  removeGroup(groupId, ev) {
    ev.stopPropagation();
    this.GroupService.deleteGroup(groupId).then(() => {
      _remove(this.groups, group => group.id === groupId);
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto grupę')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  hasAccess(id) {
    const group = _find(this.groups, group => group.id === id);
    if (group && group.default) {
      return false;
    }

    return true;
  }
}

export const Groups = {
  bindings: {
    me: '<',
    groups: '<'
  },
  template,
  controller: GroupsComponent
};
